<script>
  import { onMount } from "svelte";
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import { Pulse } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import OrderStyles from "./OrderStyles/OrderStyles.svelte";
  import CutSheetPrint from "../FStyles/Utils/CutSheetPrint.svelte";

  let loading = true;

  export let params;
  const { id } = params;

  let order = null;

  let authData = { headers: { authorization: ls.get("jwt") } };

  const loadData = async () => {
    loading = true;

    axios
      .get(`${$config.backendURL}/orders/${id}`, authData)
      .then((res) => {
        order = res.data;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onMount(async () => {
    loadData();
  });

  const handleCloseOrder = () => {
    const confirmed = confirm(`Close the order?`);
    if (!confirmed) return;

    axios
      .put(
        `${$config.backendURL}/orders/${id}`,
        { completed: true, completedOn: new Date().toISOString() },
        authData
      )
      .then((res) => loadData())
      .catch((err) => console.log(err));
  };

  const handleReopenOrder = () => {
    const confirmed = confirm(`Reopen the order?`);
    if (!confirmed) return;

    axios
      .put(
        `${$config.backendURL}/orders/${id}`,
        { completed: false, completedOn: new Date().toISOString() },
        authData
      )
      .then((res) => loadData())
      .catch((err) => console.log(err));
  };
</script>

<svelte:head>
  <title>Order Details | Fabi CC System</title>
</svelte:head>

<Layout>
  <div class="py-2" />

  {#if loading}
    <div class="loading-screen h-screen flex items-center justify-center">
      <Pulse size="100" color="rgb(16, 185, 129)" unit="px" />
    </div>
  {:else}
    <div class="flex justify-end mb-6">
      {#if order.completed}
        <button class="btn btn-green-outline" on:click={handleReopenOrder}>
          <i class="fas fa-check-circle mr-3" />
          Reopen Order
        </button>
      {:else}
        <button class="btn btn-red-outline" on:click={handleCloseOrder}>
          <i class="fas fa-times-circle mr-3" />
          Close Order
        </button>
      {/if}
      <a
        class="ml-3 btn btn-gray-outline"
        use:link
        href={`/customers/${order.customerID}`}
      >
        <i class="fas fa-eye mr-3" />
        View Customer
      </a>
      <a class="ml-3 btn btn-green-outline" use:link href="/orders">
        <i class="fas fa-arrow-left mr-3" />
        Return to Orders
      </a>
    </div>

    <!-- ORDER AGGREGATE HERE -->

    <!-- MANAGE STYLES HERE -->
    <MenuHeading
      title="Styles Ordered - ORDER #{order.orderID}"
      description="Add/Remove/Edit Styles Ordered here..."
    />

    <OrderStyles
      orderID={order._id}
      orderStyles={order.items}
      orderNumber={order.orderID}
      dateOrdered={order.dateOrdered}
      customerID={order.customerID}
      on:reloadData={() => loadData()}
    />
  {/if}
</Layout>
